import React from 'react';
import InternalCheckbox from './Checkbox';
import Collapsable from './Collapsable';
import Group from './Group';
import { Props as CheckboxProps } from './Checkbox/types';

export type {
  CheckboxProps,
  CheckboxChangeEvent,
  CheckboxGroupProps,
  CheckboxOptionType,
} from './types';

interface CompoundedComponent
  extends React.ForwardRefExoticComponent<CheckboxProps & React.RefAttributes<HTMLInputElement>> {
  Collapsable: typeof Collapsable;
  Group: typeof Group;
}

const Checkbox = InternalCheckbox as CompoundedComponent;

Checkbox.Collapsable = Collapsable;
Checkbox.Group = Group;

export default Checkbox;
